export default __webpack_public_path__ + "static/link-item-icon-dont-2bb59426af005be20d65049a93b02e0a.png";